export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ hxSpuStatus, applicationStatus }) => {
      return !!(
        !['Q'].includes(hxSpuStatus) ||
        (applicationStatus && ['P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_delete_product') || '删除产品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ hxSpuStatus, applicationStatus }) => {
      return !!(
        !['Q'].includes(hxSpuStatus) ||
        (applicationStatus && ['P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_full_member') || '转正产品',
    icon: 'el-icon-circle-check',
    menuType: 'fullMember',
    allow: 'F',
    divided: true,
    disabled: ({ hxSpuStatus }) => !['Q'].includes(hxSpuStatus),
  },
  {
    text: that.$l('btn_add_sku') || '添加SKU',
    icon: 'el-icon-circle-plus-outline',
    menuType: 'addSku',
    divided: true,
    allow: 'K',
    disabled: ({ hxSpuStatus }) => !['Y'].includes(hxSpuStatus),
  },
]
